import { createAsyncTypes } from 'utils/ActionCreator'

export const GROUP_SETTINGS_NAME_REQUEST_ASYNC = createAsyncTypes(
  'GROUP_SETTINGS_NAME_REQUEST',
  'Settings/GROUP_SETTINGS_NAME_REQUEST'
)
